import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const StarIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M12.5751 6.88317L10.0001 1.6665L7.42508 6.88317L1.66675 7.72484L5.83342 11.7832L4.85008 17.5165L10.0001 14.8082L15.1501 17.5165L14.1667 11.7832L18.3334 7.72484L12.5751 6.88317Z"
                fill={props.fill ?? 'none'}
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
